// ~/plugins/click-outside.client.js
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
    const clickOutside = {
        beforeMount(el, binding) {
            el.__clickOutsideHandler__ = (event) => {
                // if click is completely outside the element, invoke the callback
                if (!(el === event.target || el.contains(event.target))) {
                    binding.value(event);
                }
            };

            document.addEventListener('click', el.__clickOutsideHandler__);
        },
        unmounted(el) {
            document.removeEventListener('click', el.__clickOutsideHandler__);
            delete el.__clickOutsideHandler__;
        },
    };

    nuxtApp.vueApp.directive('click-outside', clickOutside);
});
